import Mock from 'mockjs';

const Random = Mock.Random;
/**
 * 获取封禁列表
 */
Mock.mock('https://udp.oaslab.net/v6/login_ban/list?game_code=aaen', () => {
    return Mock.mock({
        'result|50': [{
            "type": "uid",
            "player_id": /\d{11}/,
            'device_id': Mock.mock('@word'),
            "status|1-0": 1,
            'expired_time': Random.date('yyyy-MM-dd'),
            "operation_type|1-2": 1,
            "operate": "@CNAME",
            "updated_time": Random.date('yyyy-MM-dd'),
            "allow_auto_process|0-1": 1,
            "game_code": "mtester",
            'logs': [],
            'note': '备注备注备注备注备注',
            'record_id': Random.increment(),
        }]
    })
})


// WEBPACK FOOTER //
// ./website/mock/index.js